import { Component, Vue } from 'vue-property-decorator';
import { ProfessionModule } from '@/store/modules/profession';
import { AppModule } from '@/store/modules/app';
import { JobType } from '@/types/ProfessionType';
import { extractJobFilters } from '@/api/AiTool';

@Component({
  name: 'AiJobSearchMixin',
})
export default class AiJobSearchMixin extends Vue {
  async applyAiFilters(text: string, isSearch = false) {
    const normalizedText = text?.trim();
    if (!normalizedText) {
      if (isSearch) {
        ProfessionModule.SetLastAiSearchText('');
        ProfessionModule.SetLastAiSearchEmpty(true);
        ProfessionModule.SET_QUERY_SEARCH_DEFAULT();
        ProfessionModule.SET_FILTER_DEFAULT();
        ProfessionModule.SET_SEARCH_DEFAULT();
        ProfessionModule.SET_PARAMS_DEFAULT();
        ProfessionModule.SET_TAGS_DEFAULT();
        ProfessionModule.SetProfessionTitle('');
        ProfessionModule.SetJobType(JobType.search);

        AppModule.SetVisibleMap(false);
        AppModule.SetVisibleJobs(true);
        AppModule.SetVisibleClusterJobs(false);
        AppModule.SET_WELCOME(true);
        this.$router.push({ name: 'Jobs', query: { lang: AppModule.language } });
      }
      return;
    }
    try {
      ProfessionModule.SetLastAiSearchText(normalizedText);
      const response = await extractJobFilters({ text: normalizedText, sid: AppModule.languageSid });
      const f = response?.filters;
      if (!f) {
        ProfessionModule.SetLastAiSearchEmpty(true);
        return;
      }

      if (isSearch) {
        ProfessionModule.SET_QUERY_SEARCH_DEFAULT();
        ProfessionModule.SET_FILTER_DEFAULT();
        ProfessionModule.SET_SEARCH_DEFAULT();
        ProfessionModule.SET_PARAMS_DEFAULT();
        ProfessionModule.SET_TAGS_DEFAULT();
        ProfessionModule.SetProfessionTitle('');
        ProfessionModule.SetJobType(JobType.search);
      }

      if (f.professions?.length) {
        const professionItems = f.professions.map((p: { code: string, name: string }) => ({
          id: p.code,
          name: p.name,
          title: p.name,
        }));
        ProfessionModule.SetSearchJobProfession(professionItems);
        ProfessionModule.SetSearchJobProfessionTitle(professionItems);
        ProfessionModule.SetSearch({
          obj: 'profession_id',
          value: professionItems.map((v: any) => v.id).join(','),
        });
      } else {
        ProfessionModule.SetSearchJobProfession(null);
        ProfessionModule.SetSearchJobProfessionTitle(null);
        ProfessionModule.SetSearch({ obj: 'profession_id', value: null });
      }

      if (f.locations?.length) {
        const loc = f.locations[0];
        const locationObj = { id: loc.id, name: loc.name };
        ProfessionModule.SetSearchJobLocation(locationObj);
        ProfessionModule.SetSearchJobLocationTitle(locationObj);
        ProfessionModule.SetSearch({ obj: 'location_id', value: loc.id });
      } else {
        ProfessionModule.SetSearchJobLocation(null);
        ProfessionModule.SetSearchJobLocationTitle(null);
        ProfessionModule.SetSearch({ obj: 'location_id', value: null });
      }

      if (f.radius != null && f.radius > 0) {
        const radiusVal = Number(f.radius);
        ProfessionModule.SetSearch({ obj: 'radius', value: radiusVal });
        ProfessionModule.SetSearchTags({ tag: 'radius', value: radiusVal });
      } else {
        ProfessionModule.SetSearch({ obj: 'radius', value: 0 });
        ProfessionModule.SetSearchTags({ tag: 'radius', value: null });
      }

      const qParts = [...new Set([
        ...(f.skills || []),
        ...(f.context_keywords || []),
      ].filter(Boolean))];
      if (qParts.length) {
        const q = qParts.join(' ');
        ProfessionModule.SetSearch({ obj: 'q', value: q });
        ProfessionModule.SetSearch({ obj: 'qmode', value: 2 });
        ProfessionModule.SetSearchTags({ tag: 'textTag', value: q });
        ProfessionModule.SetSearchTags({ tag: 'keywordTags', value: qParts });
      } else {
        ProfessionModule.SetSearch({ obj: 'q', value: '' });
        ProfessionModule.SetSearchTags({ tag: 'textTag', value: null });
        ProfessionModule.SetSearchTags({ tag: 'keywordTags', value: null });
      }

      const jobFilterKeys = [
        'fulltime', 'parttime', 'minijob', 'edujob', 'praktikum', 'dejob', 'recruit', 'tmpjob',
        'workjob', 'specialjob',
      ];
      if (f.job_types?.length) {
        f.job_types.forEach((key: string) => {
          const k = key.toLowerCase();
          if (jobFilterKeys.includes(k)) {
            ProfessionModule.SetFilter({ obj: k, value: 1 });
          }
        });
      }
      if (f.not_job_types?.length) {
        f.not_job_types.forEach((key: string) => {
          const k = key.toLowerCase();
          if (jobFilterKeys.includes(k)) {
            ProfessionModule.SetFilter({ obj: k, value: 0 });
          }
        });
      }

      const hasAnyFilters = !!(
        f.professions?.length
        || f.locations?.length
        || (f.radius != null && f.radius > 0)
        || qParts.length
        || f.job_types?.length
        || f.not_job_types?.length
      );
      ProfessionModule.SetLastAiSearchEmpty(!hasAnyFilters);

      if (isSearch) {
        AppModule.SetVisibleMap(false);
        AppModule.SetVisibleJobs(true);
        AppModule.SetVisibleClusterJobs(false);
        AppModule.SET_WELCOME(true);
        this.$router.push({ name: 'Jobs', query: { lang: AppModule.language } });
      }
    } catch (err) {
      console.error('AiJobSearchMixin.applyAiFilters', err);
    }
  }
}
